module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.zslist), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "row-li"
    }, [_c('div', {
      staticClass: "flex-center"
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/images/other/de-left.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "s-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../../assets/images/other/de-right.png"),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:item.id}}"
      }],
      staticClass: "row-banner"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _vm._m(1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-li"
  }, [_c('div', {
    staticClass: "flex-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/other/de-left.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/images/other/de-right.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-contact"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/other/contact.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e0e8330","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Saishizhaoshang.vue
// module id = 2205
// module chunks = 0